export const formatter = {
  time: (time: string) => {
    if (/^[0-9]{2}:[0-9]{2}/.test(time)) {
      return time // already formatted
    }

    return `${time.slice(0, 2)}:${time.slice(2)}`
  },
  /** Format DDMMYY to DD/MM/YYYY */
  date: (date: string) => {
    if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(date)) {
      return date // already formatted
    }

    const [d, m, y] = [
      date.slice(0,2),
      date.slice(2,4),
      date.slice(4,6)
    ]

    const Y = +y + 2000

    return `${d}/${m}/${Y}`
  },
}